<template>
<div>
  <v-layout row justify-end>
    <v-dialog v-model="displayModal2" max-width="700">
      <v-btn flat slot="activator" color="green lighten-2" light>
        <v-icon class="mr-1" small>add_box</v-icon> Add Todo</v-btn>
      <v-card>
        <v-card-title>
          <span class="headline">Add Post</span>
        </v-card-title>
        <v-card-text>
          <v-text-field v-validate="'required'" :error-messages="errors.collect('newTodo')" data-vv-name="newTodo" color="green" v-model="newTodo" placeholder="Title" class="text-input" required />
          <v-text-field label="Due by" v-validate="'required'" :error-messages="errors.collect('dueDate')" data-vv-name="dueDate" color="green" type="datetime-local" name="dueDate" v-model="dueDate" />
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green lighten-2" flat @click="clearValid()">
            Cancel
          </v-btn>
          <v-btn color="green lighten-2" flat @click="addTodo">
            Add Todo
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
  <v-card flat tile class="text-xs-left mb-2" v-for="(todo, idx) in todos" :key="idx">
    <v-card-text>
      <v-layout row wrap>
        <v-flex xs8>
          <v-icon v-if="todo.isComplete" color="green" style="float:left">check_box</v-icon>
          <h3 class="mb-1" v-bind:class="{ complete: todo.isComplete }"><v-icon>note</v-icon> {{todo.text}}</h3>
          <p class="caption mb-0">
            <v-icon small>av_timer</v-icon> {{ todo.dueDate | getTime }}
          </p>
        </v-flex>
        <v-flex xs4 class="text-xs-right">
          <a class="d-inline-block mr-2" small fab flat color="green" @click="openEdit(todo.id, todo.text, todo.dueDate, todo.isComplete)">
            <v-icon color="green">edit</v-icon>
          </a>
          <a class="d-inline-block" small fab flat color="red" @click="openDelete(todo.id)">
            <v-icon color="red">delete</v-icon>
          </a>
        </v-flex>
      </v-layout>
      <v-dialog v-model="removePost" max-width="500">
        <v-card>
          <v-card-title>
            <span class="headline">Delete Post</span>
          </v-card-title>
          <v-card-text>
            <p>Are you sure you want to permanently delete this todo?</p>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green lighten-2" flat @click="removePost = false">
              Cancel
            </v-btn>
            <v-btn color="red" outline @click="deleteTodo(todo.id)">
              Delete
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="editPost" max-width="700">
        <v-card>
          <v-card-title>
            <span class="headline">Edit Todo</span>
          </v-card-title>
          <v-card-text>
            <v-text-field :value="todo.text" color="green" class="text-input" v-model="editDetails.text" />
            <v-text-field :value="todo.dueDate" color="green" type="datetime-local" name="dueDate" v-model="editDetails.dueDate" />
            <v-checkbox :value="todo.isComplete" :input-value="todo.isComplete" label="Completed" color="green" v-model="editDetails.isComplete">
            </v-checkbox>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green lighten-2" flat @click="editPost = false">
              Cancel
            </v-btn>
            <v-btn color="green lighten-2" flat @click="editTodo(todo.id, todo.text, todo.dueDate, todo.isComplete)">
              Update
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card-text>
  </v-card>
</div>
</template>
<script>
import editorOptions from '@/scripts/editor-options'
import firebase, {
  FirebaseConsts,
  db
} from "@/firebaseConfig";

export default {
  name: "Todo",
  data() {
    return {
      todos: [],
      newTodo: '',
      text: '',
      dueDate: '',
      isComplete: false,
      displayModal2: false,
      editPost: false,
      removePost: false,
      toggle_none: 0,
      editDetails: {
        id: '',
        text: '',
        dueDate: '',
        isComplete: false
      },
      dictionary: {
        custom: {
          newTodo: {
            required: () => 'Title can not be empty',
            // custom messages
          }
        }
      },
      editorOptions
    };
  },
  mounted() {
    this.$validator.localize('en', this.dictionary)
  },
  methods: {
    addTodo() {
      this.$validator.validateAll()
      var todo = this.newTodo.trim();
      var dueDate = this.dueDate;
      if (todo) {
        db.collection("projects")
          .doc(this.$route.params.groupID)
          .collection("todos")
          .add({
            text: todo,
            dueDate: dueDate,
            isComplete: false
          }).then(ref => {
            this.displayModal2 = false;
            this.newTodo = "";
            this.dueDate = "";
            this.$validator.reset();
          }).catch(err => {
            console.log(err)
          });
      }
    },
    openEdit(id, text, dueDate, isComplete) {
      this.editPost = true
      this.editDetails.id = id
      this.editDetails.text = text
      this.editDetails.dueDate = dueDate
      this.editDetails.isComplete = isComplete
    },
    editTodo(id) {
      var id = this.editDetails.id;
      var title = this.editDetails.text.trim();
      var due = this.editDetails.dueDate;
      var done = this.editDetails.isComplete;
      db.collection("projects").doc(this.$route.params.groupID).collection('todos').doc(id).update({
        text: title,
        dueDate: due,
        isComplete: done
      }).then(ref => {
        this.editPost = false;
        this.editDetails.text = "";
        this.editDetails.dueDate = "";
        this.editDetails.isComplete = "";
      }).catch(err => {
        console.log(err)
      });
    },
    openDelete(id) {
      this.removePost = true
      this.editDetails.id = id
    },
    deleteTodo(id) {
      var id = this.editDetails.id
      db.collection("projects").doc(this.$route.params.groupID).collection('todos').doc(id).delete()
      this.removePost = false
    },
    clearValid() {
      this.displayModal2 = false;
      this.$validator.reset();
    },
    loadGroupTodos() {
      this.$bind(
        "todos",
        db
        .collection("projects")
        .doc(this.$route.params.groupID)
        .collection("todos")
        .orderBy("dueDate", "asc")
      ).then(todos => {
        this.todos === todos;
      });
    }
  },
  created() {
    this.loadGroupTodos();
  },
  filters: {
    getTime(value) {
      const dateFormat = "M" + "/" + "D" + "/" + "YYYY" + " - " + "h:mm A";
      return dateFns.format(value, dateFormat);
    }
  },
  watch: {
    // Reload the group's messages when the user switches groups
    "$route.params.groupID" (id) {
      this.loadGroupTodos();
    }
  }
};
</script>

<style lang="scss" scoped>
$main-color: #388E3C;
$text-color: #4c4c4c;
$text-color-light: #cccccc;
$bg-color: #a1eec4;
$hover-color: #f7f7f7;
$neutral-color: #ffffff;
.v-input input {
    width: 100%;
    min-width: 100vw;
}
.ql-toolbar.ql-snow {
    background: #f2f2f2;
    background-color: #f2f2f2;
}
.complete {
    text-decoration: line-through;
    color: #7a7a7a;
}
</style>



// WEBPACK FOOTER //
// src/components/Posts/Todo.vue